import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import '../style/navbar.css';
import imgLogo from '../images/Logorein-01.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Navbar = () => {
  let phoneNumber = '+4917425009900';
  const navRef = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
    setIsOpen(!isOpen);
  };
  
  const closeNavbar = () => {
    setIsOpen(false);
    console.log('clicked');
  };

  return (
    <header>
      <div className='logo-main'>
        <Link to='/'>
          <LazyLoadImage className='img-logo-main' src={imgLogo}/>
        </Link>
      </div>
      <nav ref={navRef} className={isOpen ? 'responsive_nav' : ''}>
        <Link className='link-nav' to="/" onClick={closeNavbar}>Home</Link>
        <Link className='link-nav' to="/uberuns" onClick={closeNavbar}>Über uns</Link>
        <Link to="dienstleistungen" className='link-nav' onClick={closeNavbar}>Dienstleistungen</Link>
        <Link to="/kontakt" className='link-nav' onClick={closeNavbar}>Kontakt</Link>
        <button
          className="nav-btn nav-close-btn"
          onClick={closeNavbar}>
          <FaTimes style={{ color: 'var(--mainColor)' }} />
        </button>
        <a href={`tel:${phoneNumber}`} className='contact-number'>Kontakt</a>
      </nav>
      <button className="nav-btn" onClick={showNavbar}>
        <FaBars />
      </button>
    </header>
  );
}

export default Navbar;
